const REFETCH_DATA_TYPES = {
    BADGES: 'badges',
    REWARDS: 'rewards',
} as const;

export type RefetchDataType = (typeof REFETCH_DATA_TYPES)[keyof typeof REFETCH_DATA_TYPES];

export default REFETCH_DATA_TYPES;
